export function formatDateView(dateString) {
  if (!dateString || typeof dateString !== 'string') {
    return '';
  }
  // Extrai ano, mês e dia usando substring
  const year = dateString.substring(0, 4);
  const month = dateString.substring(5, 7);
  const day = dateString.substring(8, 10);
  // Retorna a data formatada no estilo DD/MM/YYYY
  return `${day}/${month}/${year}`;
}

export function formatYearView(dateString) {
  if (!dateString || typeof dateString !== 'string') {
    return '';
  }
  // Extrai ano, mês e dia usando substring
  const year = dateString.substring(0, 4);
  const month = dateString.substring(5, 7);
  const day = dateString.substring(8, 10);
  // Retorna a data formatada no estilo DD/MM/YYYY
  return `${year}`;
}

export function formatTimeView(timeString) {
  if (!timeString || typeof timeString !== 'string') {
    return '';
  }
  // Garante que a string tem pelo menos 5 caracteres (HH:mm)
  return timeString.substring(0, 5);
}

// Função para calcular dias úteis anteriores
export function calcularDiasUteisAnteriores(data, dias) {
  const newDate = new Date(data);
  let diasRestantes = dias;

  while (diasRestantes > 0) {
    newDate.setDate(newDate.getDate() - 1);

    // Verifica se não é sábado (6) ou domingo (0)
    if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
      diasRestantes--;
    }
  }
}
